import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ar from './locales/ar.json';
import tr from './locales/tr.json';
import hi from './locales/hi.json';
import ta from './locales/ta.json';
import ms from './locales/ms.json';
import ru from './locales/ru.json';
import ja from './locales/ja.json';
import zh from './locales/zh.json';
import ko from './locales/ko.json';

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧', dir: 'ltr' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦', dir: 'rtl' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷', dir: 'ltr' },
  { code: 'hi', name: 'हिन्दी', flag: '🇮🇳', dir: 'ltr' },
  { code: 'ta', name: 'தமிழ்', flag: '🇮🇳', dir: 'ltr' },
  { code: 'ms', name: 'Bahasa Melayu', flag: '🇲🇾', dir: 'ltr' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺', dir: 'ltr' },
  { code: 'ja', name: '日本語', flag: '🇯🇵', dir: 'ltr' },
  { code: 'zh', name: '中文', flag: '🇨🇳', dir: 'ltr' },
  { code: 'ko', name: '한국어', flag: '🇰🇷', dir: 'ltr' },
];

export const CURRENCIES = [
  { code: 'GBP', symbol: '£', name: 'British Pound', rate: 1 },
  { code: 'USD', symbol: '$', name: 'US Dollar', rate: 1.27 },
  { code: 'EUR', symbol: '€', name: 'Euro', rate: 1.17 },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', rate: 4.67 },
  { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal', rate: 4.76 },
  { code: 'TRY', symbol: '₺', name: 'Turkish Lira', rate: 40.5 },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', rate: 106.5 },
  { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit', rate: 5.65 },
  { code: 'RUB', symbol: '₽', name: 'Russian Ruble', rate: 118.0 },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', rate: 190.0 },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', rate: 9.2 },
  { code: 'KRW', symbol: '₩', name: 'Korean Won', rate: 1740.0 },
  { code: 'PKR', symbol: 'Rs', name: 'Pakistani Rupee', rate: 354.0 },
  { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka', rate: 152.0 },
  { code: 'EGP', symbol: 'E£', name: 'Egyptian Pound', rate: 62.0 },
  { code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah', rate: 20100.0 },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      tr: { translation: tr },
      hi: { translation: hi },
      ta: { translation: ta },
      ms: { translation: ms },
      ru: { translation: ru },
      ja: { translation: ja },
      zh: { translation: zh },
      ko: { translation: ko },
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
